/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/ban-types */
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { ColumnType } from './definitions';
import { fieldDefinitions, formModelDefinitions } from './mapping';

export class FormMapper {
  public static buildForm(target: Object, value?: any): AbstractControl {
    const groupDefinition = formModelDefinitions.find(
      (def) => def.targetConstructor === target,
    );
    if (!groupDefinition) {
      throw new Error(`undefined formModel for ${(target as any)?.name}`);
    }

    if (groupDefinition.converter) {
      const converter = new groupDefinition.converter();
      return converter.convert(value);
    }

    const columns = fieldDefinitions.filter(
      (def) => def.targetConstructor === target,
    );

    const form = new FormGroup({});

    columns.forEach((column) => {
      let control: AbstractControl | null = null;
      const controlValue = value ? value[column.propertyName] : null;
      if (column.type === ColumnType.FIELD) {
        control = new FormControl(controlValue, {
          validators: column.validators,
          updateOn: column.updateOn,
        });
      } else if (column.type === ColumnType.SUBFORM) {
        control = this.buildForm(column.propertyType, controlValue);
      } else if (column.type === ColumnType.ARRAY) {
        control = new FormArray(
          !controlValue
            ? []
            : controlValue.map((el: { constructor: Object }) =>
                this.buildForm(el.constructor, el),
              ),
          column.validators,
        );
      }

      form.setControl(column.name, control ?? new FormControl(null));
    });

    if (groupDefinition.validators) {
      form.setValidators(groupDefinition.validators);
    }

    if (groupDefinition.asyncValidator) {
      form.setAsyncValidators(groupDefinition.asyncValidator);
    }

    if (groupDefinition.afterMapping) {
      groupDefinition.afterMapping(form);
    }

    return form;
  }
}
